import { setIn } from "final-form";
import React from "react";
import { z } from "zod";

const setInError = (errors: Record<string, string>, zodError: z.ZodIssue): Record<string, string> => {
    const path = zodError.path.join(".");
    return setIn(errors, path, zodError.message) as Record<string, string>;
};

const emptyObj: Record<string, string> = Object.create(null) as Record<string, string>;

const makeValidate = <T extends z.ZodTypeAny>(schema: T): ((values: z.infer<T>) => Promise<undefined | Record<string, string>>) =>
    async function validate(values: z.infer<T>) {
        try {
            schema.parse(values);
        } catch (error: unknown) {
            if (error instanceof z.ZodError) {
                return error.issues.reduce(setInError, emptyObj);
            }
        }
    };

export const useValidationSchema = <T extends z.ZodTypeAny>(
    schema: T,
): ((values: z.infer<T>) => Promise<undefined | Record<string, string>>) => {
    return React.useMemo(() => makeValidate(schema), [schema]);
};
